import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import ImageCropModal from './ImageCropModal';
import ImageDropzone from './ImageDropzone';

// A 4:3 sample picture, so a 16:9 crop visibly trims the top and bottom
const SAMPLE_SRC = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="1600" height="1200" viewBox="0 0 1600 1200">' +
    '<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#1683a3"/><stop offset="1" stop-color="#19ae89"/>' +
    '</linearGradient></defs>' +
    '<rect width="1600" height="1200" fill="url(#g)"/>' +
    '<circle cx="800" cy="600" r="260" fill="#fcfeff" fill-opacity="0.85"/>' +
    '<text x="800" y="640" font-family="Arial" font-size="120" text-anchor="middle" fill="#333">4:3</text>' +
    '</svg>'
)}`;

// Drop or browse an image, crop it, and show the cropped JPEG
const DropAndCrop = props => {
  const { initialSrc, fixedAspect, aspectChangeable, withInstructions } = props;
  const [src, setSrc] = useState(initialSrc || null);
  const [isOpen, setIsOpen] = useState(!!initialSrc);
  const [aspect, setAspect] = useState(fixedAspect || 16 / 9);
  const [result, setResult] = useState(null);

  const handleFileSelected = file => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      setSrc(reader.result.toString());
      setIsOpen(true);
    });
    reader.readAsDataURL(file);
  };

  const handleConfirm = file => {
    setIsOpen(false);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () =>
      setResult({ url, name: file.name, type: file.type, width: img.width, height: img.height });
    img.src = url;
  };

  return (
    <div style={{ maxWidth: 800 }}>
      <ImageDropzone
        id="ImageCropModalExample.dropzone"
        hint={<FormattedMessage id="ImageDropzone.hint" />}
        onFileSelected={handleFileSelected}
      />
      <ImageCropModal
        id="ImageCropModalExample.modal"
        isOpen={isOpen}
        src={src}
        fileName="cropped.jpg"
        aspect={aspect}
        aspectChangeable={aspectChangeable}
        onAspectChange={setAspect}
        instructions={
          withInstructions ? (
            <FormattedMessage id="EditListingPhotosForm.selectImageAreaInstructions" />
          ) : null
        }
        confirmLabel={<FormattedMessage id="EditListingPhotosForm.saveChanges" />}
        onConfirm={handleConfirm}
        onClose={() => setIsOpen(false)}
        onManageDisableScrolling={() => null}
      />
      {result ? (
        <div data-testid="cropResult">
          <p>{`${result.name} (${result.type}), ${result.width} × ${result.height}`}</p>
          <img src={result.url} alt="Cropped result" style={{ maxWidth: '100%' }} />
        </div>
      ) : null}
    </div>
  );
};

export const CoverImage = {
  component: DropAndCrop,
  props: { fixedAspect: 16 / 9, withInstructions: true },
  group: 'inputs',
};

export const CoverImageOpen = {
  component: DropAndCrop,
  props: { fixedAspect: 16 / 9, withInstructions: true, initialSrc: SAMPLE_SRC },
  useDefaultWrapperStyles: false,
  group: 'inputs',
};

export const ChangeableAspectOpen = {
  component: DropAndCrop,
  props: { aspectChangeable: true, initialSrc: SAMPLE_SRC },
  useDefaultWrapperStyles: false,
  group: 'inputs',
};
